export default __webpack_public_path__ + "static/media/JUMPILOT_LOGO.cf16ec00.png";